import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import { CopyButton } from './CopyButton';
import s from './KeyValue.module.css';

export interface KeyValueItem {
  label: ReactNode;
  value: ReactNode;
  mono?: boolean;
  /** Offer a copy button for this raw value (ids, IMEIs, VINs). */
  copy?: string | null;
  hidden?: boolean;
}

/** Label/value pairs; two columns when there is room, stacked on narrow containers. */
export function KeyValue({ items, className, dense }: { items: KeyValueItem[]; className?: string; dense?: boolean }) {
  return (
    <dl className={cx(s.kv, dense && s.kvDense, className)}>
      {items
        .filter((i) => !i.hidden)
        .map((i, idx) => (
          <div key={idx} className={s.kvRow}>
            <dt className={s.kvLabel}>{i.label}</dt>
            <dd className={cx(s.kvValue, i.mono && s.mono)}>
              {i.value === null || i.value === undefined || i.value === '' ? <span className={s.muted}>—</span> : i.value}
              {i.copy && <CopyButton value={i.copy} />}
            </dd>
          </div>
        ))}
    </dl>
  );
}
